export default __webpack_public_path__ + "static/media/tpk-2024-wave-header.663a8de1.webp";